import React from 'react';
import { call, delay, put, race, select, take } from 'redux-saga/effects';
import axios from 'axios';
import semver from 'semver';

// Types
import type { Saga } from 'redux-saga';

// Constants
import {
    VERSION_POLLING_REQUESTED,
    VERSION_POLLING_CANCELED
} from './constants';

// Components
import LocationReloadButton from '../../components/LocationReloadButton';

// Actions
import { enqueueSnackbar } from '../notifications/actions';
import { succeededPollingVersion, failedPollingVersion } from './actions';

// Selectors
import { selectIsOnline } from '../connection/selectors';

// Environment
const { REACT_APP_URL, REACT_APP_VERSION } = process.env;

export function* pollVersion(): Saga<void> {
    let latestVersion;

    while (true) {
        yield delay(60000); // 1 minute

        // Select Is Online
        const isOnline = yield select(selectIsOnline);

        const url = `${REACT_APP_URL}/versions/web`;

        if (isOnline) {
            try {
                const response = yield call(axios.get, url);
                const { version } = response.data;

                // Succeeded Polling Version
                yield put(succeededPollingVersion(response.data));

                if (
                    semver.lt(REACT_APP_VERSION, version) &&
                    latestVersion !== version
                ) {
                    latestVersion = version;

                    // Enqueue Snackbar
                    yield put(
                        enqueueSnackbar({
                            message:
                                'A new version of Orchard Hand is available',
                            options: {
                                variant: 'default',
                                action: <LocationReloadButton />,
                                autoHideDuration: undefined
                            }
                        })
                    );
                }
            } catch (error) {
                // Failed Polling Version
                yield put(failedPollingVersion(error));
            }
        }
    }
}

export function* watchVersionPollingRequested(): Saga<void> {
    while (true) {
        const action = yield take(VERSION_POLLING_REQUESTED);
        yield race([call(pollVersion, action), take(VERSION_POLLING_CANCELED)]);
    }
}
